import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientCreateConfirmView のスタイル
 */
export const hotlineClientCreateConfirmViewStyle = tv({
    slots: {
        bottomContent: ['flex flex-col gap-16 lg:gap-40', 'mt-8 lg:mt-24'],
        commentText: [textStyle({ color: 'base', size: 'sm' }), 'block', 'mt-8'],
        fieldWrap: ['pt-28 pb-32 px-16 lg:p-32'],
        list: ['flex flex-col lg:gap-24'],
    },
});
